import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconPlay = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	"aria-hidden": "true",
	focusable: "false",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M.815 1.993v14.022a1.562 1.562 0 0 0 2.284 1.386l13.43-6.987c1.12-.583 1.122-2.184.004-2.77L3.103.609A1.563 1.563 0 0 0 .815 1.993Z" })
});
export default SvgIconPlay;
